import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const Questions = (props) => {
    const { faq } = props;
    if (faq.length === 0) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'l-container-12 s-contents' }, { children: [_jsx("h2", { children: "\u3088\u304F\u3042\u308B\u8CEA\u554F" }), _jsx("div", Object.assign({ className: 's-contents-inner' }, { children: _jsx("div", Object.assign({ className: 'content-box b-faq' }, { children: faq.map(({ answer, id, question }) => (_jsxs("dl", { children: [_jsx("dt", { children: question }), _jsx("dd", { children: _jsx(SplitText, { text: answer }) })] }, id))) })) }))] })));
};
Questions.propTypes = {
    faq: propArrayShape().isRequired,
};
export default Questions;
